import { idApiTargets } from '@config/apis/id/id-api-targets';
import { AvailableApisType } from './assets/available-apis.type';
import { EnvironmentInterface } from './assets/environment.interface';
import { EnvironmentType } from './assets/environment-type';
import { notificationApiTargets } from '@config/apis/notification/notification-api-targets';

export const environment = {
  apis: {
    id: idApiTargets.staging,
    notification: notificationApiTargets.staging,
  } as Record<AvailableApisType, EnvironmentInterface>,
  debug: {
    authBundle: false,
    googleTagManager: false,
    loadingScreen: false,
    oidc: false,
    piwikPro: false,
    requestBundle: false,
    router: false,
    storageBundle: false,
  },
  testConfig: {
    useCookiebot: true,
    useGoogleTagManager: true,
    usePiwikPro: true,
  },
  formats: {
    date: 'dd.MM.yyyy',
    dateTime: 'dd.MM.yyyy HH:mm',
  },
  frontend: {
    baseUrl: 'https://angular.komponentbibliotek.fagforbundet.dev',
    redirectUrl:
      'https://angular.komponentbibliotek.fagforbundet.dev/:locale/login',
    postLogoutRedirectUri:
      'https://angular.komponentbibliotek.fagforbundet.dev',
  },
  pageTitlePrefix: 'Angular Komponentbibliotek',
  type: EnvironmentType.STAGING,
};
